import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { Subscription } from 'rxjs';

import { TitleService } from '@core/services/title.service';
import { ApprovalsService } from '@app/services/app/approvals.service';
import { AppService } from '@app/services/app/app.service';
import { LibraryService } from '@app/services/app/library.service';

import * as Search from '@app/models/search';
import * as Objects from '@core/objects';
import * as fromState from '@app/store/state/approvals/approvals.state';
import { ApprovalsMenuItem } from '@core/models/menu-item.model';

import { approvalsMenu } from './approvals.menu';
import { Session } from '@app/store/models/session.model';

@Component({
  selector: 'approvals-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class ApprovalsMainComponent implements OnInit, OnDestroy {

  public readonly ACCESS_ADD_PROJECT = "access_global_new_request";
  public readonly PLUGIN_REQUEST_FEEDBACK = 'share_feedback';
  readonly GLOBAL_ACCESS_APPROVALS = "access_global_approvals";

  public readonly SEARCH_STATUS = Search.SearchHttpStatus;

  public readonly STATUS_LOADING = 0;
  public readonly STATUS_DONE = 1;
  public readonly STATUS_NOT_ALLOWED = 2;
  public readonly STATUS_NOT_FOUND = 3;
  public readonly STATUS_ERROR = 4;
  public readonly STATUS_EMPTY = 5;

  protected approvalsStatusMenu: ApprovalsMenuItem[] = approvalsMenu;

  public status: number = 0;
  public approvalStatusSelected: string = '';

  public params: Search.SearchQueryParams = null;
  public feedbacksAccess: boolean = false; 
  public globalApprovalsAccess: boolean | string = false; // approvals control
  public currentItems: Array<Objects.Version> = null;
  public resultsStatus: fromState.ApprovalsResultsStatus = {completed: Search.SearchHttpStatus.INITIAL, uncompleted: Search.SearchHttpStatus.INITIAL}
  
  public loading: boolean = true;
  public updating: boolean = false;

  protected firstLoad: boolean = true;
  protected firstRoute: boolean = false;

  protected subs = new Subscription();

  constructor(
    private title: TitleService,
    private approvalsSrv: ApprovalsService,
    private route: ActivatedRoute,
    private app: AppService,
    private librarySrv: LibraryService
    ) {}

  ngOnInit() {
    // HERE LOAD version status Access on Library Store. 
    this.librarySrv.loadVersionsStatusAccess();
    this.title.set("Approvals");
    // detect results status paramter in url
    this.subs.add(this.route.params.subscribe((params: any) => {
      if(params.hasOwnProperty('status')) {
        // console.log("Approvals: displaying feedbacks status: "+params.status);
        this.approvalStatusSelected =  params.status == 'completed' ? 'completed' : params.status == 'outstanding' ? 'uncompleted' : '';
        this.init();
      }
    }));
    // select the current results
    this.subs.add(this.approvalsSrv.selectResultItems().subscribe((versions: Objects.Version[]) => {
      this.currentItems = versions; 
      this.updating = false;
    }));
    // result status needed to init the store.
    this.subs.add(this.approvalsSrv.selectResultStatus().subscribe((rStatus: fromState.ApprovalsResultsStatus) => {
      this.resultsStatus = rStatus;
      if(rStatus[this.approvalStatusSelected] && rStatus[this.approvalStatusSelected] == Search.SearchHttpStatus.FINAL){
        this.status = this.STATUS_DONE;
      }
   }));

    // get q, global access and plugins access
    this.subs.add(this.app.getSession().subscribe( (session: Session) => {
      // now we check plugin access and rule global access
      this.feedbacksAccess = session.options.plugins.some((pa: string) => pa == this.PLUGIN_REQUEST_FEEDBACK);
      if(session.options.access.hasOwnProperty(this.GLOBAL_ACCESS_APPROVALS) ){
        // Set globalApprovalsAccess directly from the value
        this.globalApprovalsAccess = session.options.access[this.GLOBAL_ACCESS_APPROVALS];
      }
      // let savedParams = null;
      // updated to feedback_search in session on 2023/09/18 <diego@twonas.com>
      // console.log("params in results--->", this.params,  session.options.custom.feedback_search,this.resultsStatus);
      if(this.params==null &&  session.options.custom.feedback_search) {
        this.params = session.options.custom.feedback_search!=null? session.options.custom.feedback_search : this.params;
      }

      this.status = this.STATUS_DONE;
      // init approvals only when search status is INITIAL -> is it will be DONE or FINAL each time we go back to approvals
      if(this.resultsStatus[this.approvalStatusSelected] == this.SEARCH_STATUS.INITIAL){
        this.approvalsSrv.init(this.params, this.feedbacksAccess, this.globalApprovalsAccess);
        
      }
      // session data already laoded.
      this.loading = false;
      this.init();
    }));

    this.subs.add(this.approvalsSrv.selectQueryParams().subscribe((params: Search.SearchQueryParams) => {
        this.firstLoad = true;
    }));
   
    this.subs.add(this.route.queryParams.subscribe(params => {
        if (!this.firstRoute && this.params == null)
            this.params = Search.SearchConvert.paramsFromRouteParams(params);
        
        this.firstRoute = true;
    }));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  init(){
    if(!this.loading && this.approvalStatusSelected != ''){
      this.updating = true;
      this.approvalsSrv.setResultItemsStatus(this.approvalStatusSelected);
    }
  }

}
